export default "__VITE_ASSET__58nTMTDp__"